import React from 'react';
import './GiftCardModal.scss';
import stuffCard from 'assets/images/stuffs/stuff-holding-card.svg';
import GiftCardPill from '../giftCardPill';

const GiftCardModal = () => {
	return (
		<div className="gift-card-modal-content">
			<span className="gift-card-modal-content-title">
				Gift Card Information
			</span>
			<div className="gift-card-modal-content-body">
				<img
					src={stuffCard}
					alt="smiling fuzzy yellow ball holding gift card"
				/>
				<span className="gift-card-modal-content-pitch black">
					Complete Your Rental Online.
				</span>
				<span className="gift-card-modal-content-pitch green">
					Get a $20 Visa Gift Card!
				</span>
				<span>
					We will send you a $20 Visa gift card when you complete your
					rental online
				</span>

				<div className="gift-card-modal-content-steps">
					<div className="step">
						<span className="step-number">1</span>
						<span className="step-text">
							Reserve a storage unit with the $20 gift card badge.{' '}
						</span>
						<GiftCardPill giftCardValue={20} />
					</div>
					<div className="step">
						<span className="step-number">2</span>
						<span className="step-text">
							Complete your storage rental by entering details and
							making your first payment.{' '}
						</span>
					</div>
					<div className="step">
						<span className="step-number">3</span>
						<span className="step-text">
							Sign your storage unit rental lease online.
						</span>
					</div>
					<div className="step">
						<span className="step-number">4</span>
						<span className="step-text">
							Get a $20 Visa Gift Card via your reservation email
							within 45 business days.
						</span>
					</div>
				</div>
			</div>
			<div className="gift-card-modal-content-terms">
				<span className="gift-card-modal-content-terms-title">
					Terms & Conditions
				</span>
				<ul className="gift-card-modal-content-terms-list">
					<li>
						<span className="gift-card-terms-category">
							Eligibility:
						</span>{' '}
						This promotion is open to new first time SpareFoot
						customers over the age of 21 who reserve a self-storage
						unit online through SpareFoot. The gift card will be
						awarded only upon successful completion of the online
						move-in process. Limit one gift card per customer.
						Employees of SpareFoot and its affiliates are not
						eligible.
					</li>
					<li>
						<span className="gift-card-terms-category">
							Gift Card Details:
						</span>{' '}
						The gift card will be a virtual Visa gift card issued by
						our partner, BHN Rewards. It is subject to the terms and
						conditions of our partner and the issuing provider. Gift
						cards are non-transferable and cannot be redeemed for
						cash.
					</li>
					<li>
						<span className="gift-card-terms-category">
							Reservation Requirements:
						</span>{' '}
						The storage unit reservation must be made exclusively
						through the online reservation system on Find Storage
						Units Near You with SpareFoot - The Ultimate Storage
						Unit Finder. Reservations made by phone, in person, or
						through other channels are not eligible. The reservation
						must be for a bona fide rental.
					</li>
					<li>
						<span className="gift-card-terms-category">
							Fulfillment:
						</span>{' '}
						The gift card will be delivered via the provided email
						within 45 business days after the successful online
						move-in. Please check your spam folder.
					</li>
					<li>
						<span className="gift-card-terms-category">
							General Terms:
						</span>{' '}
						SpareFoot reserves the right to modify or terminate this
						promotion at any time without prior notice. SpareFoot is
						not responsible for lost, stolen, or damaged gift cards.
					</li>
					<li>
						This promotion is subject to availability. By
						participating, you agree to these terms and conditions
						and all decisions made by SpareFoot in connection
						herewith. Void where prohibited.
					</li>
					<li>
						<span className="gift-card-terms-category">
							Privacy:
						</span>{' '}
						Any personal information collected during this promotion
						will be used in accordance with our privacy policy at
						https://www.sparefoot.com/legal/privacy.html.
					</li>
					<li>
						<span className="gift-card-terms-category">
							Governing Law:
						</span>{' '}
						This promotion and its terms and conditions shall be
						governed by and construed in accordance with the laws of
						the State of Texas.
					</li>
				</ul>
			</div>
		</div>
	);
};

export default GiftCardModal;
